<template>
    <div class="">
        <transition name="fade">
        <div v-if="sending" class="w-100 tc ph3 i f4-ns f4 fw3 mv5">
          sending...
        </div>
      </transition>

      <transition name="fade">
        <div v-if="submitted" class="w-100 tc ph3 f2-ns f3 mt5">
          <div>we'll be in touch shortly!</div>
        </div>
      </transition>

      <transition name="fade">
        <form v-if="!sending && !submitted" class="ph4 center w-80-ns w-100">
          <div class="wrap-input100 validate-input" data-validate="Name is required">
            <input v-model="name" class="input100" type="text" name="name" placeholder="Name...">
            <span class="focus-input100"></span>
          </div>

          <div class="wrap-input100 validate-input" data-validate = "Valid email is required: ex@abc.xyz">
            <input v-model="email" class="input100" type="text" name="email" placeholder="Email addess...">
            <span class="focus-input100"></span>
          </div>

          <div class="wrap-input100">
            <input v-model="phone" class="input100" type="text" name="phone" placeholder="Phone Number...">
            <span class="focus-input100"></span>
          </div>

          <div class="wrap-input100 validate-input" data-validate = "Message is required">
            <textarea v-model="message" class="input100" name="message" placeholder="Message..."></textarea>
            <span class="focus-input100"></span>
          </div>

          <div class="container ">
            <div class="wrap tc center">
              <div @click="submit" class="-bgbtn"></div>
              <button @click="submit" class="f4 b ttu tracked br2 send-btn tc w-40-ns w-80 pa3">
                Send
              </button>
            </div>
          </div>
        </form>
      </transition>
    </div>
</template>

<script>
import Form from '@/components/Form.vue'
import emailjs from 'emailjs-com'
 export default {
	name: 'ContactForm',
	data() {
		return {
      sending: false,
      submitted: false,
      error: false,
      name: '',   
      phone: '',
      email:'',   
      message:'', 
      errorMsg: ''
    }
  },
  methods: { 
    redirect: function() {
      console.log('redirect home')
      this.$router.push('/')
    }, 
    submit: function(event) {
      event.preventDefault();
      if (this.name && this.email && this.message && this.phone) {
        this.sending = true;

        var data = {
          "reply_to": this.email,
          "from_name": this.name,
          "to_name": "ProSource Insulation",
          "message_html": `${this.phone}\n\n${this.message}`
        }
        emailjs.send('service_tz0vdxa', 'template_0wfs6zp', data, 'GOTnDifwA-zvZ3Ouz')
        .then((result) => {
            // console.log('SUCCESS!', result.status, result.text);
            result
            this.sending = false;
            this.submitted = true;
        }, (error) => {
          error
            // console.log('FAILED...', error);
        });
      } else {
        alert('Form Incomplete!')
      }
    },
    onReset() {
      // Reset our form values
      this.email = ''
      this.name = ''
      this.phone = ''
      this.message = ''
    }
  }
}
</script>

<style scoped>

.send-btn {
  color: rgb(15, 55, 111, .8);
  background: #afafaf;
  background: rgb(15, 55, 111, .8);
  color: #fff;
  /* color: gold; */
}

.send-btn:hover {
  background: rgb(15, 55, 111, 1);
  color: gold;
  transition: 1s;
}

p {
	/* font-family: Poppins-Regular; */
	font-size: 14px;
	line-height: 1.7;
	color: #666666;
	margin: 0px;
}

ul, li {
	margin: 0px;
	list-style-type: none;
}

input {
	outline: none;
	border: none;
}

input[type="number"] {
    -moz-appearance: textfield;
    appearance: none;
    -webkit-appearance: none;
}

input[type="number"]::-webkit-outer-spin-button,
input[type="number"]::-webkit-inner-spin-button {
    -webkit-appearance: none;
}

textarea {
  outline: none;
  border: none;
}

textarea:focus, input:focus {
  border-color: transparent !important;
}

input:focus::-webkit-input-placeholder { color:transparent; }
input:focus:-moz-placeholder { color:transparent; }
input:focus::-moz-placeholder { color:transparent; }
input:focus:-ms-input-placeholder { color:transparent; }

textarea:focus::-webkit-input-placeholder { color:transparent; }
textarea:focus:-moz-placeholder { color:transparent; }
textarea:focus::-moz-placeholder { color:transparent; }
textarea:focus:-ms-input-placeholder { color:transparent; }

input::-webkit-input-placeholder {
  color: #cccccc;
  font-size: 1rem;
  font-weight: 300;
}
input:-moz-placeholder {color: #cccccc;}
input::-moz-placeholder {color: #cccccc;}
input:-ms-input-placeholder {color: #cccccc;}

textarea::-webkit-input-placeholder {
  color: #cccccc;
  font-size: 1rem;
  font-weight: 300;
}
textarea:-moz-placeholder {color: #cccccc;}
textarea::-moz-placeholder {color: #cccccc;}
textarea:-ms-input-placeholder {color: #cccccc;}

button {
	outline: none !important;
	border: none;
	/* background: transparent; */
}

button:hover {
	cursor: pointer;
}

iframe {
	border: none !important;
}

.wrap-input100 {
  width: 100%;
  position: relative;
  border-bottom: 1px solid #fff;
  margin-bottom: 14px;
}

.label-input100 {
  /* font-family: Poppins-SemiBold; */
  font-size: 18px;
  color: #fff;
  line-height: 1.2;
  padding-left: 2px;
}

.input100 {
  display: block;
  width: 100%;
  background: transparent;
  /* font-family: Poppins-Regular; */
  font-size: 22px;
  color:#fff;
  line-height: 1.2;
  padding: 0 2px;
}

.focus-input100 {
  position: absolute;
  display: block;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  pointer-events: none;
}

.focus-input100::before {
  content: "";
  display: block;
  position: absolute;
  bottom: -2px;
  left: 0;
  width: 0;
  height: 2px;

  -webkit-transition: all 0.4s;
  -o-transition: all 0.4s;
  -moz-transition: all 0.4s;
  transition: all 0.4s;

  background: #dfb425;
  background: -webkit-linear-gradient(45deg, #dfb425, #dfb425);
  background: -o-linear-gradient(45deg, #dfb425, #dfb425);
  background: -moz-linear-gradient(45deg, #dfb425, #dfb425);
  background: linear-gradient(45deg, #dfb425, #dfb425);
}


input.input100 {
  height: 50px;
}


textarea.input100 {
  min-height: 140px;
  padding-top: 13px;
  padding-bottom: 13px;
}

.input100:focus + .focus-input100::before {
  width: 100%;
}

.has-val.input100 + .focus-input100::before {
  width: 100%;
}

@media (max-width: 576px) {
  .wrap-contact100 {
  }
}

/*[ Alert validate ]*/

.validate-input {
  position: relative;
}

.alert-validate::before {
  content: attr(data-validate);
  position: absolute;
  max-width: 70%;
  background-color: #fff;
  border: 1px solid #dfb425;
  border-radius: 2px;
  padding: 4px 30px 4px 10px;
  bottom: calc((100% - 25px) / 2);
  -webkit-transform: translateY(50%);
  -moz-transform: translateY(50%);
  -ms-transform: translateY(50%);
  -o-transform: translateY(50%);
  transform: translateY(50%);
  right: 2px;
  pointer-events: none;

  /* font-family: Poppins-Medium; */
  color: #dfb425;
  font-size: 14px;
  line-height: 1.4;
  text-align: left;

  visibility: hidden;
  opacity: 0;

  -webkit-transition: opacity 0.4s;
  -o-transition: opacity 0.4s;
  -moz-transition: opacity 0.4s;
  transition: opacity 0.4s;
}

.alert-validate::after {
  content: "\f06a";
  /* font-family: FontAwesome; */
  display: block;
  position: absolute;
  color: #dfb425;
  font-size: 18px;
  bottom: calc((100% - 25px) / 2);
  -webkit-transform: translateY(50%);
  -moz-transform: translateY(50%);
  -ms-transform: translateY(50%);
  -o-transform: translateY(50%);
  transform: translateY(50%);
  right: 8px;
}

.alert-validate:hover:before {
  visibility: visible;
  opacity: 1;
}

@media (max-width: 992px) {
  .alert-validate::before {
    visibility: visible;
    opacity: 1;
  }
}

.true-validate::after {
  content: "\f26b";
  font-family: Material-Design-Iconic-Font;
  font-size: 22px;
  color: #00ad5f;
  display: -webkit-box;
  display: -webkit-flex;
  display: -moz-box;
  display: -ms-flexbox;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  bottom: calc((100% - 25px) / 2);
  -webkit-transform: translateY(50%);
  -moz-transform: translateY(50%);
  -ms-transform: translateY(50%);
  -o-transform: translateY(50%);
  transform: translateY(50%);
  right: 5px;
}


/*==================================================================
[ Contact more ]*/

.contact100-more {
  /* font-family: Poppins-Medium; */
  font-size: 16px;
  color: #fff;

  position: fixed;
  z-index: -1;
  display: -webkit-box;
  display: -webkit-flex;
  display: -moz-box;
  display: -ms-flexbox;
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 212px;
  height: 50px;
  border-radius: 25px;
  background-color: #39b54a;
  padding: 0 20px;

  top: 50%;
  left: calc((100% - 640px) / 2);
  -webkit-transform: translate(-50%, -50%);
  -moz-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  -o-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}

.contact100-more i {
  font-size: 20px;
  margin-right: 10px;
}



@media (max-width: 1200px) {
  .wrap-contact100 {
    /* width: 440px; */
  }

  .contact100-map {
    width: 100% !important;
  }

  .contact100-more {
    left: calc((100% - 440px) / 2);
  }
}

@media (max-width: 768px) {
  .wrap-contact100 {
    width: 100%;
  }

  .contact100-map {
    width: 100% !important;
    height: 50vh;
  }

  .contact100-more {
    /* position: absolute; */
    background-color: transparent;
    color: #39b54a;
    bottom: 0px;
    top: auto;
    left: 50%;
    z-index: 10;
  }

}
</style>